import React, { CSSProperties, ElementType, ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react';
import cx from 'classnames';

import styles from './Content.module.scss';

type ContentProps = Partial<{
  center: boolean;
  children: ReactNode;
  className: string;
  element: ElementType;
  forwardedRef: ForwardedRef<Element | null | undefined>;
  style: CSSProperties;
  wrapper: HTMLAttributes<HTMLDivElement>;
  wrapperContentPost: ReactNode;
  wrapperContentPre: ReactNode;
}>

const ContentBase = ({
  center,
  children,
  className,
  element,
  forwardedRef,
  wrapper,
  wrapperContentPost,
  wrapperContentPre,
  ...p
}: ContentProps) => {
  const ContainerElement = element || 'div';

  let content = (
    <ContainerElement
      ref={forwardedRef}
      className={cx(
        styles.content,
        className,
        {
          [styles.center]: center,
        },
      )}
      {...p}
    >
      {children}
    </ContainerElement>
  );

  if (wrapper) {
    content = (
      <div {...wrapper}>
        {wrapperContentPre}
        {content}
        {wrapperContentPost}
      </div>
    );
  }

  return content;
};

export const Content = forwardRef((props: ContentProps, ref: ContentProps['forwardedRef']) => (
  <ContentBase {...props} forwardedRef={ref} />
));
